import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Team() {
  return (
    <Container>
      <Row className="g-0">
        <Col className="mb-3 g-0"></Col>
      </Row>
      <Row>
        <Col></Col>
      </Row>
    </Container>
  );
}

export default Team;
